/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkAmounts
 */
export interface WorkAmounts {
    /**
     * 
     * @type {Date}
     * @memberof WorkAmounts
     */
    workedDate: Date;
    /**
     * 
     * @type {number}
     * @memberof WorkAmounts
     */
    workAmount: number;
}

/**
 * Check if a given object implements the WorkAmounts interface.
 */
export function instanceOfWorkAmounts(value: object): value is WorkAmounts {
    if (!('workedDate' in value) || value['workedDate'] === undefined) return false;
    if (!('workAmount' in value) || value['workAmount'] === undefined) return false;
    return true;
}

export function WorkAmountsFromJSON(json: any): WorkAmounts {
    return WorkAmountsFromJSONTyped(json, false);
}

export function WorkAmountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkAmounts {
    if (json == null) {
        return json;
    }
    return {
        
        'workedDate': (new Date(json['workedDate'])),
        'workAmount': json['workAmount'],
    };
}

export function WorkAmountsToJSON(value?: WorkAmounts | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workedDate': ((value['workedDate']).toISOString().substring(0,10)),
        'workAmount': value['workAmount'],
    };
}

